import loadScript from 'load-script';
import { externalScripts } from '../../config';

// The minimum possible delay to not overlap lighthouse score measurement
const SCRIPT_LOADING_DELAY = 2000;

export const loadExternalScripts = () =>
  setTimeout(() => {
    externalScripts.forEach(({ before, link, after }) => {
      if (before) {
        // eslint-disable-next-line no-eval
        eval(before);
      }

      loadScript(link, () => {
        if (after) {
          // eslint-disable-next-line no-eval
          eval(after);
        }
      });
    });
  }, SCRIPT_LOADING_DELAY);
